import { useState } from "react";
import { Helmet } from "react-helmet";
const categories = ["All", "iFLO A/C Education", "News", "Drain Line Cleaning"];
import Header from "./components/header";
import Footer from "./components/footer";


export default function BlogIndex() {

    const page = 'blogHome'

    /*useEffect(() => {
        document.body.style.backgroundColor = page === "blogHome" ? "#040404" : "white";
    }, [page]);*/

    

    return (
        <div>
            <Helmet>
                <title>iFLO PRO Blog - HVAC Education, News & Tips</title>
                <meta name="description" content="Stay updated with the latest HVAC education, news, and tips from iFLO PRO. Learn about air conditioning maintenance, drain line cleaning, and innovative HVAC solutions." />
                <meta name="keywords" content="HVAC education, air conditioning tips, drain line cleaning, HVAC news, iFLO PRO, HVAC maintenance" />
                <meta property="og:title" content="iFLO PRO Blog - HVAC Education, News & Tips" />
                <meta property="og:description" content="Stay updated with the latest HVAC education, news, and tips from iFLO PRO. Learn about air conditioning maintenance, drain line cleaning, and innovative HVAC solutions." />
                <meta property="og:image" content="https://cdn.shopify.com/s/files/1/0768/7353/1706/files/banner_ad-1.jpg?v=1733161347" />
                <meta property="og:url" content="https://iflopro.com/blog" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="iFLO PRO Blog - HVAC Education, News & Tips" />
                <meta name="twitter:description" content="Stay updated with the latest HVAC education, news, and tips from iFLO PRO. Learn about air conditioning maintenance, drain line cleaning, and innovative HVAC solutions." />
                <meta name="twitter:image" content="https://cdn.shopify.com/s/files/1/0768/7353/1706/files/banner_ad-1.jpg?v=1733161347" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Blog",
                        "name": "iFLO PRO Blog",
                        "description": "Stay updated with the latest HVAC education, news, and tips from iFLO PRO. Learn about air conditioning maintenance, drain line cleaning, and innovative HVAC solutions.",
                        "image": "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/banner_ad-1.jpg?v=1733161347",
                        "url": "https://iflopro.com/blog",
                        "publisher": {
                            "@type": "Organization",
                            "name": "iFLO PRO",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://iflopro.com/logo.png"
                            }
                        },
                        "blogPost": blogData.flatMap(category => 
                            category.articles.map(article => ({
                                "@type": "BlogPosting",
                                "headline": article.title,
                                "image": article.image.src,
                                "description": article.summary,
                                "url": article.link,
                                "datePublished": article.publishedAt || new Date().toISOString(),
                                "author": {
                                    "@type": "Organization",
                                    "name": "iFLO PRO"
                                }
                            }))
                        )
                    })}
                </script>
            </Helmet>
            <Header />
            <div className="relative h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('https://cdn.shopify.com/s/files/1/0768/7353/1706/files/banner_ad-1.jpg?v=1733161347')", backgroundAttachment: "fixed" }}>
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
            
            {/* Content */}
            <div className="absolute bottom-8 left-8 text-white space-y-4">
            <span className="px-3 py-1 bg-gray-800 bg-opacity-50 rounded-full text-sm">A/C Education</span>
            
            <h1 className="text-4xl font-bold">In the know with iFLO</h1>
            
            <p className="text-lg text-gray-300 max-w-lg">
                Stay updated on the latest news, reviews, articles and more featuring the greatest innovation in HVAC!
            </p>
            
            </div>
            
            </div>
            <BlogCards />
            <Footer />
      </div>
    );
}

const blogData = [
    {
        title: "iFLO A/C Education",
        handle: "iflo-ac-education",
        articles: [
            {
                title: "What is iFLO?",
                handle: "what-is-iflo",
                image: {
                    src: "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/what-is-iflo.jpg?v=1733161347",
                    altText: "What is iFLO?"
                },
                summary: "Learn more about the innovative technology that is iFLO, and how it can help you prevent costly water damage from your air conditioning unit.",
                link: "https://iflopro.com/blogs/iflo-ac-education/what-is-iflo"
            },
            {
                title: "Why Do I Need iFLO?",
                handle: "why-do-i-need-iflo",
                image: {
                    src: "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/why-do-i-need-iflo.jpg?v=1733161347",
                    altText: "Why Do I Need iFLO?"
                },
                summary: "Discover the benefits of using iFLO, including preventing water damage, reducing maintenance costs, and keeping your air conditioning unit running at its best.",
                link: "https://iflopro.com/blogs/iflo-ac-education/why-do-i-need-iflo"
            },
            {
                title: "How Does iFLO Work?",
                handle: "how-does-iflo-work",
                image: {
                    src: "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/how-does-iflo-work.jpg?v=1733161347",
                    altText: "How Does iFLO Work?"
                },
                summary: "Find out more about the technology behind iFLO, and how it uses a combination of sensors and a specially designed drainage system to prevent water damage from your air conditioning unit.",
                link: "https://iflopro.com/blogs/iflo-ac-education/how-does-iflo-work"
            }
        ]
    },
    {
        title: "News",
        handle: "news",
        articles: [
            {
                title: "Solving HVAC Drain Line Backups with iFLO Pro | July 2024",
                handle: "todays-ac",
                image: {
                    src: "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/iflo-featured-in-achr-news.jpg?v=1733161347",
                    altText: "iFLO Featured in ACHR News"
                },
                summary: "For Homeowners: With iFLO Pro, homeowners experience fewer disruptions and enjoy a more reliable HVAC system. The innovative design ensures that the system runs smoothly, preventing water damage...",
                link: "https://todays-ac.com/wp-content/uploads/2024/07/EntireJuly2024Issue.pdf"
            },
            {
                title: "iFLO Featured in HVACR Business",
                handle: "iflo-featured-in-hvacr-business",
                image: {
                    src: "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/iflo-featured-in-hvacr-business.jpg?v=1733161347",
                    altText: "iFLO Featured in HVACR Business"
                },
                summary: "iFLO was featured in the latest issue of HVACR Business, where we discussed the importance of preventative maintenance and how iFLO can help.",
                link: "https://hvacrbusiness.com/articles/144323-iflo-featured-in-hvacr-business"
            }
        ]
    },
    {
        title: "Drain Line Cleaning",
        handle: "drain-line-cleaning",
        articles: [
            {
                title: "The Importance of Drain Line Cleaning",
                handle: "the-importance-of-drain-line-cleaning",
                image: {
                    src: "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/the-importance-of-drain-line-cleaning.jpg?v=1733161347",
                    altText: "The Importance of Drain Line Cleaning"
                },
                summary: "Learn more about the importance of drain line cleaning, and how it can help prevent costly water damage from your air conditioning unit.",
                link: "https://iflopro.com/blogs/drain-line-cleaning/the-importance-of-drain-line-cleaning"
            },
            {
                title: "How to Clean Your Drain Line",
                handle: "how-to-clean-your-drain-line",
                image: {
                    src: "https://cdn.shopify.com/s/files/1/0768/7353/1706/files/how-to-clean-your-drain-line.jpg?v=1733161347",
                    altText: "How to Clean Your Drain Line"
                },
                summary: "Get step-by-step instructions on how to clean your drain line, and find out how iFLO can make the process easier and more effective.",
                link: "https://iflopro.com/blogs/drain-line-cleaning/how-to-clean-your-drain-line"
            }
        ]
    }
];

const BlogCards = () => {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [sortOrder, setSortOrder] = useState(""); // Track the selected sort order
  
    // Flatten all articles into a single array
    const allArticles = blogData.flatMap((blog) =>
      blog.articles.map((edge) => ({
        ...edge,
        blogHandle: blog.handle,
        title: blog.title,
      }))
    );
    // Filter by category
    const filteredArticles =
    selectedCategory === "All"
      ? allArticles
      : allArticles.filter((article) =>
          article.title.includes(selectedCategory)
        );

  
    // Sort by time
    const sortedArticles = [...filteredArticles].sort((a, b) => {
      const dateA = new Date(a.publishedAt || 0);
      const dateB = new Date(b.publishedAt || 0);
      if (sortOrder === "newest") return dateB - dateA; // Newest first
      if (sortOrder === "oldest") return dateA - dateB; // Oldest first
      return 0; // No sorting if no sort order selected
    });
  
    return (
    <div className="bg-[#0f0f0f]">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-3xl text-white font-bold">The iFLO PRO Blog</h1>
        </div>
  
        {/* Categories & Sort */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-6 space-y-4 md:space-y-0">
          {/* Categories */}
          <div className="flex flex-wrap md:flex-row flex-col w-full space-x-0 md:space-x-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full text-sm ${
                  selectedCategory === category
                    ? "bg-yellow-400 text-white"
                    : "bg-gray-200 text-gray-700"
                } m-1 md:m-0`}
              >
                {category}
              </button>
            ))}
          </div>
  
          {/* Sort Dropdown */}
          <div className="relative mt-4 md:mt-0">
            <select
              className="bg-gray-200 text-gray-900 text-sm rounded-full px-4 py-2 focus:outline-none"
              onChange={(e) => setSortOrder(e.target.value)} // Update sort order
            >
              <option value="">Sort by Time</option>
              <option value="newest">Newest</option>
              <option value="oldest">Oldest</option>
            </select>
          </div>
        </div>
  
        {/* Blog Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {sortedArticles.map((article) => (
            <div className="relative rounded-lg overflow-hidden border-[1px] border-[#919191]" key={article.handle}>
              {/* Image */}
              <img
                src={article.image?.src || "/placeholder.jpg"}
                alt={article.image?.altText || "Blog image"}
                className="w-full h-48 object-cover"
              />
  
              {/* Category Label */}
              <span className="absolute top-4 left-4 px-3 py-1 bg-gray-800 text-white text-sm rounded-md">
                {article.title}
              </span>
  
              {/* Summary */}
              <p className="px-4 py-2 text-sm text-gray-700">
                {article.summary}
              </p>
  
              {/* Link */}
              <a
                href={article.link}
                className="px-4 py-2 text-sm text-yellow-400 hover:text-yellow-500"
              >
                Read More
              </a>
            </div>
          ))}
        </div>
      </div>
      </div>
    );
  };

